import {
  captureDocumentSelection,
  restoreDocumentSelection,
} from '@/lib/documentSelectionPreserve';

/**
 * Копирует текст в буфер: Clipboard API, при ошибке — execCommand (HTTP, ограничения браузера).
 * По умолчанию восстанавливает выделение в документе (fallback через textarea снимает его).
 */
export async function copyPlainTextToClipboard(
  text: string,
  options?: { preserveSelection?: boolean },
): Promise<boolean> {
  const value = text.trim();
  if (!value) return false;

  const preserveSelection = options?.preserveSelection !== false;
  const savedRanges = preserveSelection ? captureDocumentSelection() : [];

  try {
    if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
      try {
        await navigator.clipboard.writeText(value);
        return true;
      } catch {
        /* fallback */
      }
    }

    try {
      const ta = document.createElement('textarea');
      ta.value = value;
      ta.setAttribute('readonly', '');
      ta.setAttribute('aria-hidden', 'true');
      ta.style.position = 'fixed';
      ta.style.left = '-9999px';
      ta.style.top = '0';
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      if (typeof ta.setSelectionRange === 'function') {
        ta.setSelectionRange(0, value.length);
      }
      const ok = document.execCommand('copy');
      document.body.removeChild(ta);
      return ok;
    } catch {
      return false;
    }
  } finally {
    if (preserveSelection) {
      restoreDocumentSelection(savedRanges);
    }
  }
}
